import app from 'flarum/forum/app';
import { track } from './analytics';
import { extend, override } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import LinkButton from 'flarum/common/components/LinkButton';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Dropdown from 'flarum/common/components/Dropdown';
import Separator from 'flarum/common/components/Separator';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Avatar from 'flarum/common/components/Avatar';
import CommentPost from 'flarum/forum/components/CommentPost';
import UserPage from 'flarum/forum/components/UserPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import UserCard from 'flarum/forum/components/UserCard';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';
import NotificationsDropdown from 'flarum/forum/components/NotificationsDropdown';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import listItems from 'flarum/common/helpers/listItems';
import humanTime from 'flarum/common/helpers/humanTime';
import username from 'flarum/common/helpers/username';
import extractText from 'flarum/common/utils/extractText';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
const t = (key, values) => app.translator.trans('bydtalk.forum.' + key, values);
const openVehicles = () => app.btEditVehicles?.();
const tags = () => app.store.all('tags').filter(tag => !tag.isHidden()).sort((a, b) => (b.discussionCount() || 0) - (a.discussionCount() || 0));
const signIn = () => {
  app.drawer.hide();
  app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
};
const newDiscussion = () => {
  app.drawer.hide();
  IndexSidebar.prototype.newDiscussionAction().catch(() => {});
};
const tagPill = tag => m(Link, {
  className: "BydTalkPill",
  title: tag.name(),
  href: app.route.tag(tag)
}, tag.name());
const card = (title, icon, content, action) => m("section", {
  className: "BydTalkPanel"
}, m("div", {
  className: "BydTalkPanel-heading"
}, m("h2", null, m(Icon, {
  name: icon
}), t(title)), action), content);
const vehicleName = vehicle => vehicle.label || app.forum.attribute('btVehicleLabels')?.models?.[vehicle.model]?.[vehicle.market] || app.forum.attribute('btVehicleLabels')?.models?.[vehicle.model]?.default || vehicle.model;
const vehicleDetails = vehicle => [vehicle.year, app.forum.attribute('btVehicleLabels')?.markets?.[vehicle.market] || vehicle.market].filter(Boolean).join(' · ');
const vehicleImage = vehicle => app.forum.attribute('btVehicleLabels')?.images?.[vehicle.model]?.[vehicle.market || 'default'];
const modelImage = (image, name) => image && m("img", {
  className: "BydTalkOfficialVehicleImage",
  src: app.forum.attribute('baseUrl') + '/' + image.path,
  alt: image.alt || name,
  title: t('model_image_help'),
  loading: "lazy"
});
const discussionActivity = discussion => {
  const replied = discussion.replyCount() > 0;
  const user = replied ? discussion.lastPostedUser() : discussion.user();
  const time = replied ? discussion.lastPostedAt() : discussion.createdAt();
  return m("span", {
    className: "BydTalkDiscussionActivity"
  }, m(Icon, {
    name: replied ? 'fas fa-reply' : 'far fa-clock'
  }), m("span", null, t(replied ? 'last_reply_text' : 'posted_text', {
    username: username(user),
    ago: humanTime(time)
  })));
};
class CommunitySearch extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.query = '';
  }
  search(query) {
    if (query === void 0) {
      query = this.query;
    }
    if (!query.trim()) return;
    track('search_submit', {
      source: 'community'
    });
    m.route.set(app.route('index', {
      q: query.trim()
    }));
  }
  view() {
    return card('community_search', 'fas fa-wand-magic-sparkles', m('[', null, m("p", {
      className: "BydTalkSearchTitle"
    }, t('ask_byd')), m("p", null, t('search_help')), m("form", {
      className: "BydTalkAsk",
      onsubmit: event => {
        event.preventDefault();
        this.search();
      }
    }, m("input", {
      "aria-label": t('ask_placeholder'),
      placeholder: t('ask_placeholder'),
      value: this.query,
      oninput: event => this.query = event.target.value,
      maxlength: "300"
    }), m(Button, {
      type: "submit",
      className: "Button Button--icon",
      icon: "fas fa-arrow-right",
      disabled: !this.query.trim(),
      "aria-label": t('search_submit')
    })), m("div", {
      className: "BydTalkSuggestions"
    }, m("span", null, t('try_asking')), m("div", null, ['ask_update', 'ask_charging', 'ask_models'].map(key => m(Button, {
      className: "BydTalkPill",
      onclick: () => this.search(app.translator.trans('bydtalk.forum.' + key, {}, true))
    }, t(key)))))));
  }
}
class ExploreContent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  async load() {
    this.discussions = [];
    this.loading = true;
    this.failed = false;
    try {
      this.discussions = await app.store.find('discussions', {
        sort: '-lastPostedAt',
        include: ['user', 'lastPostedUser'],
        page: {
          limit: 3
        }
      });
    } catch {
      this.failed = true;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  view() {
    return m("section", {
      className: "BydTalkExploreContent"
    }, m(CommunitySearch, null), card('trending_tags', 'fas fa-fire', m("ol", {
      className: "BydTalkTrending"
    }, tags().slice(0, 5).map((tag, index) => m("li", null, m("span", {
      className: "BydTalkRank"
    }, index + 1), tagPill(tag), m("span", null, t('discussion_total', {
      count: tag.discussionCount() || 0
    })))))), card('latest_discussions', 'fas fa-file-lines', this.loading ? m(LoadingIndicator, null) : this.failed ? m('[', null, m("p", null, t('load_error')), m(Button, {
      className: "Button Button--link",
      onclick: () => this.load()
    }, t('try_again'))) : this.discussions.length ? m("div", {
      className: "BydTalkLatest"
    }, this.discussions.map(discussion => m(Link, {
      href: app.route.discussion(discussion)
    }, m("strong", null, discussion.title()), m("span", null, app.translator.trans('core.forum.discussion_list.total_replies_a11y_label', {
      count: discussion.replyCount()
    })), discussionActivity(discussion)))) : m("p", null, t('no_discussions')), m(Link, {
      href: app.route('index')
    }, t('view_all'), " ", m(Icon, {
      name: "fas fa-arrow-right"
    }))), m(Link, {
      className: "BydTalkCommunityCard",
      href: app.route('members')
    }, m(Icon, {
      name: "fas fa-users"
    }), m("div", null, m("strong", null, t('global_community')), m("span", null, t('community_description'))), m(Icon, {
      name: "fas fa-angle-right"
    })));
  }
}
class ParticipatedDiscussions extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.request = 0;
    this.load();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (this.userId !== this.attrs.user.id()) this.load();
  }
  onremove() {
    this.request++;
  }
  async load() {
    this.userId = this.attrs.user.id();
    const request = ++this.request;
    this.loading = true;
    this.failed = false;
    this.discussions = [];
    try {
      const results = await app.store.find('discussions', {
        filter: {
          participant: this.attrs.user.slug()
        },
        page: {
          limit: 3
        }
      });
      if (request === this.request) this.discussions = results.map(discussion => ({
        discussion,
        participatedAt: new Date(discussion.attribute('btLastParticipatedAt'))
      }));
    } catch {
      if (request === this.request) this.failed = true;
    } finally {
      if (request === this.request) {
        this.loading = false;
        m.redraw();
      }
    }
  }
  view() {
    return m("section", {
      className: "BydTalkProfileDiscussions"
    }, m("div", {
      className: "BydTalkSectionHeading"
    }, m("div", null, m("h2", null, m(Icon, {
      name: "far fa-comments"
    }), t('participated_discussions')), m("p", null, t('participated_discussions_help'))), m(Link, {
      href: app.route('user.posts', {
        username: this.attrs.user.slug()
      })
    }, t('view_all'), " ", m(Icon, {
      name: "fas fa-arrow-right"
    }))), this.loading ? m(LoadingIndicator, null) : this.failed ? m(Button, {
      className: "Button",
      onclick: () => this.load()
    }, t('try_again')) : this.discussions.length ? m("div", {
      className: "BydTalkLatest"
    }, this.discussions.map(_ref => {
      let {
        discussion,
        participatedAt
      } = _ref;
      return m(Link, {
        href: app.route.discussion(discussion)
      }, m("strong", null, discussion.title()), m("span", null, discussion.replyCount(), " ", t('replies'), " \xB7 ", humanTime(participatedAt)));
    })) : m("p", {
      className: "BydTalkEmpty"
    }, t('no_participated_discussions')));
  }
}
class RelatedDiscussions extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.request = 0;
    this.load();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (this.discussionId !== this.attrs.discussion.id()) this.load();
  }
  onremove() {
    this.request++;
  }
  async load() {
    this.discussionId = this.attrs.discussion.id();
    const request = ++this.request;
    this.loading = true;
    this.failed = false;
    this.discussions = [];
    const discussion = this.attrs.discussion;
    const slugs = discussion.tags()?.map(tag => tag.slug()) || [];
    try {
      if (slugs.length) {
        const results = await app.store.find('discussions', {
          filter: {
            tag: slugs.join(',')
          },
          sort: '-lastPostedAt',
          page: {
            limit: 4
          }
        });
        if (request === this.request) this.discussions = results.filter(item => item.id() !== discussion.id()).slice(0, 3);
      }
    } catch {
      if (request === this.request) this.failed = true;
    } finally {
      if (request === this.request) {
        this.loading = false;
        m.redraw();
      }
    }
  }
  view() {
    return m("section", {
      className: "BydTalkRelatedDiscussions"
    }, m("div", {
      className: "BydTalkSectionHeading"
    }, m("h2", null, m(Icon, {
      name: "far fa-comments"
    }), t('related_discussions'))), this.loading ? m(LoadingIndicator, null) : this.failed ? m(Button, {
      className: "Button",
      onclick: () => this.load()
    }, t('try_again')) : this.discussions.length ? m("div", {
      className: "BydTalkLatest"
    }, this.discussions.map(discussion => m(Link, {
      href: app.route.discussion(discussion)
    }, m("strong", null, discussion.title()), m("span", null, discussion.replyCount(), " ", t('replies'), " \xB7 ", humanTime(discussion.lastPostedAt()))))) : m("p", {
      className: "BydTalkEmpty"
    }, t('no_related_discussions')));
  }
}
class Garage extends Component {
  view() {
    const user = this.attrs.user;
    const own = user === app.session.user;
    const vehicles = user.attribute('btVehicles') || [];
    return m("section", {
      className: "BydTalkGarage"
    }, m("div", {
      className: "BydTalkSectionHeading"
    }, m("div", null, m("h2", null, m(Icon, {
      name: "fas fa-car"
    }), t(own ? 'my_garage' : 'profile_garage')), m("p", null, t(own ? 'garage_help' : 'profile_garage_help'))), own && m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: openVehicles
    }, t('add_vehicle'))), vehicles.length ? m("div", {
      className: "BydTalkGarageGrid"
    }, vehicles.map((vehicle, index) => m("article", {
      className: "BydTalkGarageCard"
    }, modelImage(vehicleImage(vehicle), vehicleName(vehicle)) || m("div", {
      className: "BydTalkVehicleIcon"
    }, m(Icon, {
      name: "fas fa-car"
    })), m("div", {
      className: "BydTalkGarageCard-body"
    }, m("div", null, m("h3", null, vehicleName(vehicle)), index === 0 && m("span", {
      className: "BydTalkPrimary"
    }, t('primary_vehicle'))), m("p", null, vehicleDetails(vehicle)), m("div", {
      className: "BydTalkPills"
    }, [vehicle.powertrain, vehicle.year].filter(Boolean).map(value => m("span", {
      className: "BydTalkPill"
    }, value)), own && m(Button, {
      className: "Button Button--link",
      icon: "fas fa-pen",
      onclick: openVehicles
    }, t('edit_vehicle'))))))) : m("div", {
      className: "BydTalkGarageEmpty"
    }, m(Icon, {
      name: "fas fa-car"
    }), m("h3", null, t(own ? 'no_vehicles_short' : 'no_profile_vehicles')), own && m("p", null, t('no_vehicles')), own && m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: openVehicles
    }, t('add_vehicle'))), own && m("div", {
      className: "BydTalkQuickLinks"
    }, m(Link, {
      href: app.route('following')
    }, m(Icon, {
      name: "far fa-bookmark"
    }), m("div", null, m("strong", null, t('followed_discussions')), m("span", null, t('followed_help')))), m(Link, {
      href: app.route('tags')
    }, m(Icon, {
      name: "fas fa-tags"
    }), m("div", null, m("strong", null, t('explore_tags')), m("span", null, t('find_topics')))), m(Link, {
      href: app.route('user.discussions', {
        username: user.slug()
      })
    }, m(Icon, {
      name: "far fa-file-lines"
    }), m("div", null, m("strong", null, t('my_posts')), m("span", null, t('discussion_total', {
      count: user.discussionCount() || 0
    })))), m(Link, {
      href: app.route('settings')
    }, m(Icon, {
      name: "fas fa-gear"
    }), m("div", null, m("strong", null, t('settings')), m("span", null, t('manage_preferences'))))), m(ParticipatedDiscussions, {
      user: user
    }));
  }
}
class GaragePage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    if (app.session.user) this.loadUser(app.session.user.slug());else {
      this.bodyClass = 'App--garage';
      app.setTitle(app.translator.trans('bydtalk.forum.my_garage', {}, true));
    }
  }
  view() {
    if (!app.session.user) return m(PageStructure, {
      className: "BydTalkDirectory"
    }, m("div", {
      className: "BydTalkGarageEmpty"
    }, m(Icon, {
      name: "fas fa-car"
    }), m("h1", null, t('my_garage')), m("p", null, t('garage_signin')), m(Button, {
      className: "Button Button--primary",
      onclick: signIn
    }, t('sign_in'))));
    return super.view();
  }
  content() {
    return m(Garage, {
      user: this.user
    });
  }
}
class ModelsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.market = '';
    this.query = '';
    this.load();
    app.setTitle(app.translator.trans('bydtalk.forum.explore_models', {}, true));
  }
  async load() {
    this.loading = true;
    this.failed = false;
    try {
      this.catalog = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/bydtalk/vehicles'
      });
    } catch {
      this.failed = true;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  view() {
    const models = this.catalog?.models.filter(model => (!this.market || model.offerings[this.market]) && [model.name, ...Object.values(model.offerings).map(offering => offering.name)].some(name => name.toLowerCase().includes(this.query.toLowerCase()))) || [];
    return m(PageStructure, {
      className: "BydTalkModels"
    }, m("h1", null, t('explore_models')), m("p", null, t('model_directory_help')), this.loading ? m(LoadingIndicator, null) : this.failed ? m(Button, {
      className: "Button",
      onclick: () => this.load()
    }, t('try_again')) : m('[', null, m("div", {
      className: "BydTalkModelFilters"
    }, m("label", null, m("span", null, t('market')), m("select", {
      className: "FormControl",
      value: this.market,
      onchange: event => this.market = event.target.value
    }, m("option", {
      value: ""
    }, t('all_markets')), this.catalog.markets.map(market => m("option", {
      value: market.id
    }, market.name)))), m("label", null, m("span", null, t('model')), m("input", {
      className: "FormControl",
      value: this.query,
      oninput: event => this.query = event.target.value,
      placeholder: t('find_model')
    }))), m("div", {
      className: "BydTalkGarageGrid"
    }, models.map(model => m("article", {
      className: "BydTalkGarageCard"
    }, modelImage(this.market ? model.offerings[this.market].image : model.image, this.market ? model.offerings[this.market].name : model.name) || m("div", {
      className: "BydTalkVehicleIcon"
    }, m(Icon, {
      name: "fas fa-car"
    })), m("div", {
      className: "BydTalkGarageCard-body"
    }, m("h3", null, this.market ? model.offerings[this.market].name : model.name), m("p", null, Object.entries(model.offerings).filter(_ref2 => {
      let [market] = _ref2;
      return !this.market || market === this.market;
    }).map(_ref3 => {
      let [market, offering] = _ref3;
      return (this.catalog.markets.find(item => item.id === market)?.name || market) + (offering.status === 'historical' ? ' (' + t('historical_model') + ')' : '');
    }).join(' · ')), m(Link, {
      className: "Button",
      href: app.route('index', {
        q: 'model:' + model.id + (this.market ? ' market:' + this.market : '')
      })
    }, t('model_discussions'), " ", m(Icon, {
      name: "fas fa-arrow-right"
    })), m("a", {
      className: "Button Button--link",
      href: this.market ? model.offerings[this.market].source : model.source,
      target: "_blank",
      rel: "noopener noreferrer"
    }, t('model_source'), " ", m(Icon, {
      name: "fas fa-arrow-up-right-from-square"
    })))))), !models.length && m("p", {
      className: "BydTalkEmpty"
    }, t('no_models')), m("p", {
      className: "BydTalkFieldHelp"
    }, t('model_image_help'), " ", t('catalog_help'))));
  }
}
class ExplorePage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(app.translator.trans('bydtalk.forum.explore', {}, true));
  }
  view() {
    return m(PageStructure, {
      className: "BydTalkExplore"
    }, m("h1", {
      className: "BydTalkPageTitle"
    }, t('explore')), m("nav", {
      className: "BydTalkExploreTabs"
    }, m(Link, {
      className: "is-active",
      href: app.route('explore')
    }, m(Icon, {
      name: "fas fa-wand-magic-sparkles"
    }), t('community_search_short')), m(Link, {
      href: app.route('garage')
    }, m(Icon, {
      name: "fas fa-car"
    }), t('my_garage'))), m(ExploreContent, null));
  }
}
class MembersPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.users = [];
    this.offset = 0;
    this.load();
    app.setTitle(app.translator.trans('bydtalk.forum.members', {}, true));
  }
  async load() {
    if (!app.forum.attribute('canSearchUsers')) return;
    this.loading = true;
    this.failed = false;
    try {
      const users = await app.store.find('users', {
        page: {
          limit: 24,
          offset: this.offset
        },
        sort: '-joinedAt'
      });
      this.users.push(...users);
      this.more = !!users.payload?.links?.next;
      this.offset += users.length;
    } catch {
      this.failed = true;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  view() {
    const canView = app.forum.attribute('canSearchUsers');
    return m(PageStructure, {
      className: "BydTalkDirectory"
    }, m("h1", null, t('members')), m("p", null, t('community_description')), !canView ? m("div", {
      className: "BydTalkGarageEmpty"
    }, m("p", null, app.session.user ? app.translator.trans('core.lib.error.permission_denied_message') : t('members_signin')), !app.session.user && m(Button, {
      className: "Button Button--primary",
      onclick: signIn
    }, t('sign_in'))) : m('[', null, m("div", {
      className: "BydTalkMembers"
    }, this.users.map(user => m(UserCard, {
      user: user
    }))), this.loading ? m(LoadingIndicator, null) : this.failed ? m(Button, {
      className: "Button",
      onclick: () => this.load()
    }, t('try_again')) : this.more && m(Button, {
      className: "Button",
      onclick: () => this.load()
    }, t('load_more'))));
  }
}
class AboutPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(app.translator.trans('bydtalk.forum.about', {}, true));
  }
  view() {
    return m(PageStructure, {
      className: "BydTalkDirectory"
    }, m("article", {
      className: "BydTalkAbout"
    }, m("h1", null, t('about_bydtalk')), m("p", {
      className: "BydTalkLead"
    }, t('community_description')), m("img", {
      src: app.forum.attribute('baseUrl') + '/brand/community-coast-v2.webp',
      alt: ""
    }), m("h2", null, t('drive_together')), m("p", null, t('about_help')), m("p", null, t('independence')), m("div", {
      className: "BydTalkActions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: newDiscussion
    }, t('join_conversation')), m(Link, {
      className: "Button",
      href: app.route('tags')
    }, t('explore_tags')))));
  }
}
class MobileNav extends Component {
  view() {
    const route = app.current.get('routeName') || '';
    const discussion = app.current.get('discussion');
    const reply = () => discussion && DiscussionControls.replyAction.call(discussion, false, false).catch(() => {});
    const replyLabel = app.translator.trans(app.session.user ? 'core.forum.discussion_controls.reply_button' : 'core.forum.discussion_controls.log_in_to_reply_button');
    const inDiscussion = ['discussion', 'discussion.near', 'bydtalk.localized', 'bydtalk.localized.near'].includes(route);
    return m('[', null, m("header", {
      className: "BydTalkMobileHeader"
    }, inDiscussion && m(Link, {
      className: "Button Button--icon",
      href: app.route('index'),
      "aria-label": t('back_home')
    }, m(Icon, {
      name: "fas fa-arrow-left"
    })), m(Link, {
      className: "BydTalkMobileLogo",
      href: app.route('index'),
      "aria-label": "BYDTalk"
    }, m("img", {
      className: "Header-logo",
      src: app.forum.attribute('logoUrl'),
      alt: "BYDTalk"
    }), m("img", {
      className: "Header-logo Header-logo--dark-mode",
      src: app.forum.attribute('logoDarkModeUrl'),
      alt: ""
    })), m(GlobalSearch, {
      state: app.search.state
    }), !inDiscussion && m(Button, {
      className: "Button Button--primary Button--icon",
      icon: "fas fa-plus",
      "aria-label": t('new_post'),
      onclick: newDiscussion
    }), app.session.user ? m(SessionDropdown, null) : m(Dropdown, {
      className: "BydTalkGuestMenu",
      buttonClassName: "Button Button--icon",
      icon: "far fa-user",
      label: t('more')
    }, m(Button, {
      icon: "fas fa-right-to-bracket",
      onclick: signIn
    }, t('sign_in')), m(Button, {
      icon: "fas fa-globe",
      onclick: () => app.btEditLanguages?.()
    }, t('reading_language')))), inDiscussion ? discussion && m("div", {
      className: "BydTalkMobileReply"
    }, app.session.user && m(Avatar, {
      user: app.session.user
    }), m(Button, {
      className: "BydTalkReplyField",
      disabled: !!app.session.user && !discussion.canReply(),
      onclick: reply
    }, app.session.user ? app.translator.trans(discussion.canReply() ? 'core.forum.post_stream.reply_placeholder' : 'core.forum.discussion_controls.cannot_reply_button') : replyLabel), m(Button, {
      className: "Button Button--primary Button--icon",
      disabled: !!app.session.user && !discussion.canReply(),
      icon: "fas fa-reply",
      "aria-label": extractText(replyLabel),
      onclick: reply
    })) : m("nav", {
      className: "BydTalkBottomNav",
      "aria-label": t('main_navigation')
    }, m(Link, {
      className: ['index', 'tag'].includes(route) ? 'is-active' : '',
      href: app.route('index')
    }, m(Icon, {
      name: "fas fa-house"
    }), m("span", null, t('home'))), m(Link, {
      className: ['tags', 'explore'].includes(route) ? 'is-active' : '',
      href: app.route('explore')
    }, m(Icon, {
      name: "far fa-compass"
    }), m("span", null, t('explore'))), app.session.user ? m(NotificationsDropdown, {
      state: app.notifications
    }) : m(Button, {
      className: "Button Button--link",
      icon: "far fa-bell",
      onclick: signIn
    }, t('notifications')), m(Button, {
      className: "Button Button--link",
      icon: "fas fa-bars",
      onclick: () => app.drawer.show()
    }, t('more'))));
  }
}
app.initializers.add('bydtalk-theme-layout', () => {
  override(TagsPage.prototype, 'hero', () => null);
  extend(TagsPage.prototype, 'contentItems', items => {
    items.add('btHeading', m("div", {
      className: "BydTalkPageHeading"
    }, m("h1", null, t('all_tags')), m("p", null, t('tags_help'))), 200);
  });
  override(TagsPage.prototype, 'cloudView', function (original, cloud) {
    return m("div", {
      className: "BydTalkTagGrid"
    }, cloud.map(tag => m(Link, {
      className: "BydTalkTagCard",
      href: app.route.tag(tag)
    }, m("h2", null, m(Icon, {
      name: tag.icon() || 'fas fa-tag'
    }), tag.name()), tag.description() && m("p", null, tag.description()), m("span", null, t('discussion_total', {
      count: tag.discussionCount() || 0
    }), m(Icon, {
      name: "fas fa-arrow-right"
    })))));
  });
  app.routes.models = {
    path: '/models',
    component: ModelsPage
  };
  app.routes.explore = {
    path: '/explore',
    component: ExplorePage
  };
  app.routes.garage = {
    path: '/garage',
    component: GaragePage
  };
  app.routes.members = {
    path: '/members',
    component: MembersPage
  };
  app.routes.about = {
    path: '/about',
    component: AboutPage
  };
  override(DiscussionPage.prototype, 'hero', function (original) {
    const items = this.sidebarItems();
    items.remove('scrubber');
    const controls = DiscussionControls.controls(this.discussion, this);
    controls.remove('reply');
    const actions = controls.toArray();
    if (actions.some(action => action.tag !== Separator)) {
      items.setContent('controls', m(Dropdown, {
        buttonClassName: "Button Button--icon",
        icon: "fas fa-ellipsis-h",
        menuClassName: "Dropdown-menu--right",
        label: t('discussion_actions'),
        accessibleToggleLabel: extractText(t('discussion_actions'))
      }, actions)).setPriority('controls', -10);
    } else {
      items.remove('controls');
    }
    const hero = original();
    hero.attrs.btActions = items.toArray();
    return m("div", {
      className: "BydTalkThreadHeading"
    }, m("nav", {
      className: "BydTalkBreadcrumb",
      "aria-label": t('breadcrumb')
    }, m(Link, {
      href: app.route('index')
    }, t('home')), m(Icon, {
      name: "fas fa-angle-right"
    }), m(Link, {
      href: app.route('index')
    }, t('discussions')), m(Icon, {
      name: "fas fa-angle-right"
    }), m("span", null, this.discussion.title())), hero);
  });
  extend(DiscussionHero.prototype, 'items', function (items) {
    if (this.attrs.btActions?.length) items.add('btActions', m("nav", {
      className: "BydTalkThreadActions",
      "aria-label": t('discussion_actions')
    }, m("ul", null, listItems(this.attrs.btActions))), 1);
  });
  override('flarum/forum/components/ReplyPlaceholder', 'view', function (original) {
    const node = original();
    if (node.tag !== 'button') return node;
    const replyLabel = app.translator.trans(app.session.user ? 'core.forum.discussion_controls.reply_button' : 'core.forum.discussion_controls.log_in_to_reply_button');
    return m(node.tag, {
      ...node.attrs,
      className: `${node.attrs.className} BydTalkReplyPrompt`,
      'aria-label': extractText(replyLabel)
    }, m("div", {
      className: "BydTalkReplyPrompt-content"
    }, app.session.user && m(Avatar, {
      user: app.session.user
    }), m("span", {
      className: "BydTalkReplyPrompt-text"
    }, app.translator.trans('core.forum.post_stream.reply_placeholder')), m("span", {
      className: "BydTalkReplyPrompt-action",
      "aria-hidden": "true"
    }, m(Icon, {
      name: "fas fa-reply"
    }), replyLabel)));
  });
  override(DiscussionPage.prototype, 'sidebar', function () {
    const items = this.sidebarItems();
    return m("nav", {
      className: "DiscussionPage-nav BydTalkScrubber"
    }, items.has('scrubber') ? items.get('scrubber') : null);
  });

  // Move the native hero into the main column without replacing page behavior.
  override(PageStructure.prototype, 'mainItems', function (original) {
    const items = original();
    items.remove('hero');
    return items;
  });
  override(PageStructure.prototype, 'providedContent', function (original) {
    const content = original();
    const user = app.current.get('user');
    const discussion = this.attrs.className === 'DiscussionPage' ? app.current.get('discussion') : null;
    return m(content.tag, content.attrs, [this.providedHero(), this.attrs.className === 'UserPage' && app.current.get('routeName') !== 'garage' ? this.sidebar() : null, this.attrs.className === 'UserPage' && ['user.posts', 'user.discussions'].includes(app.current.get('routeName')) && user && m(Garage, {
      user: user
    }), ...content.children, discussion ? this.sidebar() : null, discussion && m(RelatedDiscussions, {
      discussion: discussion
    })]);
  });
  extend(PageStructure.prototype, 'containerItems', function (items) {
    items.remove('sidebar');
  });
  const PalletSidebar = flarum.extensions['soup-97-palette-theme']?.PalletSidebar;
  if (PalletSidebar) override(PalletSidebar.prototype, 'view', function () {
    const route = app.current.get('routeName');
    const link = (key, icon, href, active) => m("li", {
      className: active ? 'active' : ''
    }, m(LinkButton, {
      icon: icon,
      href: href,
      "aria-current": active ? 'page' : undefined
    }, t(key)));
    const native = this.items();
    for (const key of Object.keys(native.toObject())) {
      if (['allDiscussions', 'tags', 'following', 'pallet-separator'].includes(key) || key.startsWith('session-')) native.remove(key);
    }
    return m("div", {
      className: "PalletSidebar-container"
    }, m("nav", {
      className: "PalletSidebar-nav",
      "aria-label": t('main_navigation')
    }, m("ul", null, link('home', 'fas fa-house', app.route('index'), route === 'index'), link('my_garage', 'fas fa-car', app.route('garage'), route === 'garage'), link('explore', 'far fa-compass', app.route('explore'), ['tags', 'explore'].includes(route)), m("li", null, m(Button, {
      icon: "fas fa-globe",
      onclick: () => app.btEditLanguages?.()
    }, t('reading_language'))), app.session.user && link('followed_discussions', 'far fa-bookmark', app.route('following'), route === 'following'), app.session.user && m("li", {
      className: "BydTalkNavNotifications"
    }, m(NotificationsDropdown, {
      state: app.notifications
    }))), m("details", {
      className: "BydTalkSideTags",
      open: true
    }, m("summary", null, t('popular_tags'), m(Icon, {
      name: "fas fa-angle-down"
    })), m("ul", null, tags().slice(0, 12).map(tag => m("li", {
      className: app.currentTag?.()?.id() === tag.id() ? 'active' : ''
    }, m(Link, {
      href: app.route.tag(tag),
      title: tag.name()
    }, m(Icon, {
      name: tag.icon() || 'fas fa-tag'
    }), m("span", null, tag.name()), m("small", null, tag.discussionCount() || 0)))), m("li", null, m(Link, {
      href: app.route('tags')
    }, m(Icon, {
      name: "fas fa-ellipsis"
    }), t('more_tags'))))), native.toArray().length > 0 && m("details", {
      className: "BydTalkSideAccount"
    }, m("summary", null, t('more'), m(Icon, {
      name: "fas fa-angle-down"
    })), m("ul", null, listItems(native.toArray())))), m(Link, {
      className: "BydTalkNewOwner",
      href: app.route('models')
    }, m(Icon, {
      name: "fas fa-car"
    }), m("div", null, m("strong", null, t('new_to_byd')), m("span", null, t('new_owner_help'))), m(Icon, {
      name: "fas fa-angle-right"
    })));
  });
  extend(HeaderPrimary.prototype, 'items', items => {
    items.add('btMembers', m(Link, {
      className: "BydTalkHeaderLink",
      href: app.route('members')
    }, t('members')), 5);
    items.add('btAbout', m(Link, {
      className: "BydTalkHeaderLink",
      href: app.route('about')
    }, t('about')), 0);
  });
  extend(HeaderSecondary.prototype, 'items', items => {
    const button = items.has('newDiscussion') ? items.get('newDiscussion') : null;
    if (button) items.setContent('newDiscussion', m(button.tag, {
      ...button.attrs,
      icon: 'fas fa-plus'
    }, t('new_post')));
  });
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    if (this.attrs.params.q) return;
    const discussion = this.attrs.discussion;
    const user = discussion.user();
    const vehicle = user?.attribute('btVehicles')?.[0];
    items.setContent('terminalPost', discussionActivity(discussion));
    items.add('btMeta', m("span", {
      className: "BydTalkDiscussionMeta"
    }, username(user), vehicle && m("span", {
      className: "BydTalkOwner"
    }, vehicleName(vehicle))), 10);
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    for (const [key, icon] of [['reply', 'far fa-comment'], ['like', 'far fa-thumbs-up']]) {
      if (!items.has(key)) continue;
      const button = items.get(key);
      items.setContent(key, m(button.tag, {
        ...button.attrs,
        icon
      }, button.children));
    }
  });
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const user = this.attrs.post.user();
    const vehicle = user?.attribute('btVehicles')?.[0];
    if (user?.id() === this.attrs.post.discussion()?.user()?.id()) items.add('btOP', m("span", {
      className: "BydTalkOP"
    }, t('original_poster')), 90);
    if (vehicle) items.add('btOwner', m("span", {
      className: "BydTalkOwner"
    }, vehicleName(vehicle)), 80);
  });
  extend(UserCard.prototype, 'contentItems', function (items) {
    if (!(this.attrs.className || '').includes('UserHero')) return;
    items.add('btHandle', m("span", {
      className: "BydTalkHandle"
    }, "@", this.attrs.user.username()), 95);
    items.add('btIntro', m("p", {
      className: "BydTalkProfileIntro"
    }, t('profile_intro')), 85);
  });
  override(UserCard.prototype, 'view', function (original) {
    const node = original();
    if (!(this.attrs.className || '').includes('UserHero')) return node;
    const user = this.attrs.user;
    return m(node.tag, node.attrs, [...node.children, m("div", {
      className: "BydTalkProfileStats"
    }, m("div", null, m("strong", null, user.commentCount() || 0), m("span", null, t('profile_posts'))), m("div", null, m("strong", null, user.discussionCount() || 0), m("span", null, t('profile_discussions'))), m("div", null, m("strong", null, user.attribute('btVehicles')?.length || 0), m("span", null, t('profile_vehicles'))), user === app.session.user && app.current.get('routeName') !== 'settings' && m(Link, {
      className: "Button",
      href: app.route('settings')
    }, m(Icon, {
      name: "fas fa-pen"
    }), " ", t('edit_profile')))]);
  });
  extend(app, 'mount', () => {
    app.store.find('tags').then(() => m.redraw()).catch(() => {});
    const node = document.createElement('div');
    node.className = 'BydTalkMobileShell';
    document.getElementById('app').append(node);
    m.mount(node, MobileNav);
  });
}, -20);